import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useAppStore } from "@/app/hooks";
import { routeByName } from "@/app/routes";
import { selectShops } from "@/features/shell/legacySelectors";
import { isConfiguring } from "@/features/shops/lib";
import type { Notification } from "@/shared/types/notification";
import { useShellDialogs } from "../dialogs";
import { notificationMeta } from "./codes";

/** "View issue": cambio shop (con la guardia) se la notifica ne ha uno, poi la rotta del codice. */
export function useNotificationRedirect() {
  const navigate = useNavigate();
  const store = useAppStore();
  const { switchShop } = useShellDialogs();
  return useCallback(
    (notification: Notification) => {
      const meta = notificationMeta(notification.code);
      if (meta.payload.includes("shopId")) {
        const shop = selectShops(store.getState()).find(
          (item) => String(item.id) === String(notification.payload.shopId),
        );
        if (shop) {
          switchShop(shop);
          if (isConfiguring(shop)) navigate("/wizard/settings");
        }
      }
      navigate(routeByName(meta.redirect ?? "")?.path ?? "/notfound");
    },
    [navigate, store, switchShop],
  );
}
